import React from "react";
import Button from "react-bootstrap/esm/Button";

function PreStart(props) {
  return (
    <div>
      <h3>Welcome to Sequences!</h3>
      <br />
      To play select "Start Game" below. The object of the game is to select the
      lights in the order that they lit up!
      <br />
      <div style={{ textAlign: "center", marginTop: "15px" }}>
        <Button onClick={() => props.setStart(true)}>Start Game</Button>
      </div>
    </div>
  );
}

export default PreStart;
